import React, { useEffect, useState } from 'react'
import { get_orders_list } from '../../api/Product';
import { Link } from 'react-router-dom';

const Order = () => {
    const [order_list, set_Order_List] = useState([]);
    console.log("order_list", order_list)

    // <---------- User Authentication Token ------------>
    const token = localStorage.getItem("token");
    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const Handle_get_order_list = async () => {
        try {
            const response = await get_orders_list(headers);
            set_Order_List(response && response)
        }
        catch (error) {
            console.log("error", error)
        }
    }
    useEffect(() => {
        Handle_get_order_list();
    }, [])
    return (
        <div>
            <div class="md:space-y-4 md:space-y-6">

                {/* <!-- component --> */}
                <div className="overflow-x-auto">
                    <table className="min-w-full leading-normal">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    S.No
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Name
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Order Id
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider md:table-cell">
                                    Price
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider md:table-cell">
                                    Quantity
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Status
                                </th>
                                <th className="md:px-2 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Receipt
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {order_list && order_list.map((order, index) => (
                                order?.items?.map((item, subIndex) => (
                                    <tr key={`${order.id}-${subIndex}`} className="bg-white border-b border-gray-200">
                                        <td className="px-2 py-2 text-sm text-gray-900">{index + 1}</td>

                                        {/* Product Orders */}
                                        {item?.product && (
                                            <>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.product?.title}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{order.id}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item.price}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item.quantity}</td>
                                            </>
                                        )}

                                        {/* Development Orders */}
                                        {item?.development && (
                                            <>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.development?.title}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.development?.id}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.development?.price}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.quantity}</td>
                                            </>
                                        )}

                                        {/* Domain Orders */}
                                        {item?.order_type == "domain" && (
                                            <>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.domain}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.id}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.price}</td>
                                                <td className="px-2 py-2 text-sm text-gray-900">{item?.quantity}</td>
                                            </>
                                        )}

                                        {/* Status Badge */}
                                        <td className="px-2 py-2 text-sm">
                                            <span className="relative inline-block px-3 py-1 font-semibold leading-tight">
                                                {order.status == "pending" ? (
                                                    <>
                                                        <span aria-hidden className="absolute inset-0 bg-yellow-500 opacity-50 rounded-full"></span>
                                                        <span className="relative text-yellow-900">{order.status}</span>
                                                    </>
                                                ) : order.status == "delivered" ? (
                                                    <>
                                                        <span aria-hidden className="absolute inset-0 bg-green-500 opacity-50 rounded-full"></span>
                                                        <span className="relative text-green-900">{order.status}</span>
                                                    </>
                                                ) : order.status == "cancelled" ? (
                                                    <>
                                                        <span aria-hidden className="absolute inset-0 bg-red-500 opacity-50 rounded-full"></span>
                                                        <span className="relative text-red-900">{order.status}</span>
                                                    </>
                                                ) : null}
                                            </span>

                                            
                                        </td>
                                        <td className="px-2 py-2 text-sm">
                                            <span className="relative inline-block font-semibold leading-tight">
                                                <Link
                                                    to={`/order-detail/${order.id}`}
                                                    className="relative inline-block text-blue-800 bg-blue-200 px-3 py-1 rounded-full hover:bg-blue-300 transition"
                                                >
                                                    View
                                                </Link>
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}

export default Order
